/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createCommissionPlanDtoFromDiscriminatorValue, createErrorResponseFromDiscriminatorValue, createInternalErrorResponseFromDiscriminatorValue, type CommissionPlanDto, type ErrorResponse, type InternalErrorResponse } from '../../../../../models/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /api/commissions/plans/active/{salesRepId}
 */
export interface WithSalesRepItemRequestBuilder extends BaseRequestBuilder<WithSalesRepItemRequestBuilder> {
    /**
     * Answers which plan a statement would be generated against: the rep's plan that is switched on and whose effective range covers `asOf`, which defaults to the current time. Both effective dates are inclusive, and a plan with either left unset is open-ended on that side. Where more than one plan qualifies, the one starting most recently wins and only that plan is returned. A 404 here is the reason statement generation fails for a rep, so call it first when a generate request is refused.
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<CommissionPlanDto>}
     * @throws {ErrorResponse} error when the service returns a 400 status code
     * @throws {InternalErrorResponse} error when the service returns a 500 status code
     */
     get(requestConfiguration?: RequestConfiguration<WithSalesRepItemRequestBuilderGetQueryParameters> | undefined) : Promise<CommissionPlanDto | undefined>;
    /**
     * Answers which plan a statement would be generated against: the rep's plan that is switched on and whose effective range covers `asOf`, which defaults to the current time. Both effective dates are inclusive, and a plan with either left unset is open-ended on that side. Where more than one plan qualifies, the one starting most recently wins and only that plan is returned. A 404 here is the reason statement generation fails for a rep, so call it first when a generate request is refused.
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toGetRequestInformation(requestConfiguration?: RequestConfiguration<WithSalesRepItemRequestBuilderGetQueryParameters> | undefined) : RequestInformation;
}
/**
 * Answers which plan a statement would be generated against: the rep's plan that is switched on and whose effective range covers `asOf`, which defaults to the current time. Both effective dates are inclusive, and a plan with either left unset is open-ended on that side. Where more than one plan qualifies, the one starting most recently wins and only that plan is returned. A 404 here is the reason statement generation fails for a rep, so call it first when a generate request is refused.
 */
export interface WithSalesRepItemRequestBuilderGetQueryParameters {
    asOf?: Date;
    useOrganizationId?: string;
}
/**
 * Uri template for the request builder.
 */
export const WithSalesRepItemRequestBuilderUriTemplate = "{+baseurl}/api/commissions/plans/active/{salesRepId}{?asOf*,useOrganizationId*}";
/**
 * Metadata for all the requests in the request builder.
 */
export const WithSalesRepItemRequestBuilderRequestsMetadata: RequestsMetadata = {
    get: {
        uriTemplate: WithSalesRepItemRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            500: createInternalErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createCommissionPlanDtoFromDiscriminatorValue,
    },
};
/* tslint:enable */
/* eslint-enable */
